import React from 'react';
import {
  PieChart,
  Users,
  BarChart,
  ShoppingBag,
  Server,
  Repeat,
  Settings,
  Layers,
  UserCheck,
  CreditCard,
  Zap,
  ShieldAlert,
} from 'lucide-react';
import { PERMISSIONS } from '../../utils/hasPermission';

// ----------------------------------------------------------------------

const getIcon = (IconComponent) => <IconComponent size={22} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(PieChart),
  },
  {
    title: 'Staff & Permissions',
    path: '/dashboard/staff',
    icon: getIcon(UserCheck),
    permission: PERMISSIONS.STAFF_READ,
  },
  {
    title: 'users',
    path: '/dashboard/user-management',
    icon: getIcon(Users),
    permission: PERMISSIONS.AGENTS_READ,
  },
  {
    title: 'analytics',
    path: '/dashboard/analytics',
    icon: getIcon(BarChart),
    permission: PERMISSIONS.TRANSACTIONS_ANALYTICS,
  },
  {
    title: 'Ad Campaigns',
    path: '/dashboard/campaigns',
    icon: getIcon(Layers),
    permission: PERMISSIONS.CAMPAIGNS_READ,
  },
  {
    title: 'Services',
    path: '/dashboard/services',
    icon: getIcon(ShoppingBag),
    permission: PERMISSIONS.SERVICES_READ,
  },
  {
    title: 'API Services',
    path: '/dashboard/reselling',
    icon: getIcon(Server),
    permission: PERMISSIONS.SERVICES_READ,
  },
  {
    title: 'Transactions',
    path: '/dashboard/transaction',
    icon: getIcon(Repeat),
    permission: PERMISSIONS.TRANSACTIONS_READ,
  },
  {
    title: 'Audit Logs',
    path: '/dashboard/audit-logs',
    icon: getIcon(ShieldAlert),
    permission: PERMISSIONS.AUDIT_READ,
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: getIcon(Settings),
    permission: [PERMISSIONS.SYSTEM_SETTINGS_READ, PERMISSIONS.SYSTEM_SETTINGS_UPDATE],
  },
  {
    title: 'Billings',
    path: '/dashboard/billing',
    icon: getIcon(CreditCard),
    isOwnerOnly: true,
  },
  // process.env.FEATURE_TOGGLE_BILLING_ACTIVES && {
  //   title: 'Feature Activations',
  //   path: '/dashboard/activations',
  //   icon: getIcon(Zap),
  //   isOwnerOnly: true,
  // },
];

export default navConfig;
